/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CheckListListItemViewModelPaginatedResponse } from "../types/CheckListListItemViewModelPaginatedResponse.ts";
import { checkListListItemViewModelSchema } from "./checkListListItemViewModelSchema.ts";

export const checkListListItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => checkListListItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<CheckListListItemViewModelPaginatedResponse>;
